// The mark: an open ring with a pupil, watched work, and the red pen's tick in the opening.
import clsx from "clsx";

export function Mark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path d="M26.2 9.2A12 12 0 1 1 20.4 4.8" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" />
      <circle cx="16" cy="16.6" r="4.4" fill="currentColor" />
      <path d="M21.6 6.4l2.6 2.7 5.4-6" fill="none" stroke="rgb(var(--signal))" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={clsx("inline-flex items-center gap-2", className)}>
      <Mark className="h-7 w-7 text-ink" />
      <span className="font-display text-[19px] font-extrabold leading-none tracking-[-0.04em]">
        Open<span className="text-ink2">Cloud</span>Security
      </span>
    </span>
  );
}
